import { SORT_PARAM } from "../constants";
import { parsePathFiltersFromPathname } from "./parsePathFiltersFromPathname";
/** Maps facets API payload + current URL into filter selected state. */
export function selectedStateFromPayload(payload, pathname = window.location.pathname, search = window.location.search) {
    var _a;
    const initialParams = (_a = payload.initialParams) !== null && _a !== void 0 ? _a : {};
    const urlSort = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search).get(SORT_PARAM);
    return Object.assign(Object.assign(Object.assign({}, initialParams), parsePathFiltersFromPathname(pathname)), (urlSort && !initialParams[SORT_PARAM] ? { [SORT_PARAM]: urlSort } : {}));
}
